import { useState, useEffect } from 'react';

const useDetectMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState({});

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  };

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    window.addEventListener('load', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (Object.entries(windowDimensions).length > 0) {
      if (windowDimensions.width < 768) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
  }, [windowDimensions]);

  return [isMobile];
};

export default useDetectMobile;
